import Schema, { required } from 'AppReact/schema';
import { inspection_tag } from 'types';

const dropdownOption = {
  id: required(['string', 'integer']),
  label: required('string'),
}

export default {
  tags: Schema(inspection_tag, 'array', { defaultValue: [] }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  textHeader: Schema('boolean', 'primitive', { defaultValue: false }),
  canRemove: Schema('boolean', 'primitive', { defaultValue: false }),
};
